import { Collapse } from 'antd';
import styled from 'styled-components';

export const CollapseMultiPanel = styled(Collapse)`
  background: rgba(#d8d8d8, 0.21);
  box-shadow: 0px 2px 3px rgba(98, 98, 98, 0.5);

  .ant-collapse-header {
    position: relative;
  }

  & > .ant-collapse-item {
    .ant-collapse-header {
      color: inherit;
      line-height: 22px;
      cursor: pointer;
      background: white;
      transition: all 0.3s;

      .anticon .anticon-right {
        position: absolute;
        top: 50%;
        right: 16px;
        left: auto;
        transform: translateY(-50%);
      }
    }

    .ant-collapse-content {
      overflow: visible;
      color: inherit;
      background-color: transparent;
      border-top: none;

      &-box {
        padding-top: 0;
      }
    }

    &.ant-collapse-item-active {
      .ant-collapse-header {
        background: transparent;
      }
    }
  }
`;
